import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function dateRangeValidator(minYear: number, maxYear: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const date = control.value;

    if (date?.year && date.month && date.day) {
      const { year } = date;

      if (year < minYear || year > maxYear) {
        return { yearOutOfRange: true };
      }
    }

    return null;
  };
}
